import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Context } from "../../store/context/context";
import Box from "@mui/material/Box";
import { Link, useNavigate, useParams } from "react-router-dom";
import useHttp from "../../store/hooks/http/useHttp";
import { useForm } from 'react-hook-form';
//ui
import Switch from '@mui/material/Switch';
// end ui
//start mix
import { checkTranslate, slugGenerate, translate } from "../../store/hooks/useMix";
import { deleteAlert, errorAlerts } from "../../store/hooks/global/useAlert";
import UseFormLang from "../../store/hooks/global/useFormLang";
import UseFileManager from "../../store/hooks/global/useFileManager";
import UseAddedBar from "../../store/hooks/components/useAddedBar";
import CircularProgress from "@mui/material/CircularProgress";
import UseButtonBar from "../../store/hooks/global/useButtonBar";

const Settings = () => {
    // use Hooks
    let http = useHttp();
    let params = useParams();
    let navigate = useNavigate();
    let { state } = useContext(Context);

    const [tabs, setTabs] = useState({
        tab_1: true,
        tab_2: false
    });

    // form data
    const [pageStatus, setPageStatus] = useState(true);
    const [pageErrors, setPageErrors] = useState(false);
    const [addSuccess, setAddSuccess] = useState(false);
    const [actionPageInMenu, setActionPageInMenu] = useState(true);
    const [updatedCovers, setUpdatedCovers] = useState([]);
    const [coverTypes, setCoverTypes] = useState([]);
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, setValue, formState: { errors }, watch, reset } = useForm();

    const resets = () => {
        reset({
            title: '',
            address: '',
            facebook: '',
            phone: '',
            youtube: '',
            google_key: '',
        }, {
            keepErrors: false,
            keepDirty: true,
            keepIsSubmitted: false,
            keepTouched: false,
            keepIsValid: false,
            keepSubmitCount: false,
        });
    }
    // End form Data

    //Get Config Options
    const getPageConfig = () => {
        http.get('options/settings').then((response) => {
            if (response.status === 200) {
                setCoverTypes(response.data.data.coverTypes)
            }
        }).catch(err => {
            console.log(err.response)
        })
        if (!params.id) {
            resets()
        }
    }

    // get edit Data
    const getEditData = () => {
        setLoading(true)
        http.get(`settings/${params.id}`, {
            params: {
                language_id: state.form_active_lang.activeLangId ? state.form_active_lang.activeLangId : null
            }
        }).then((response) => {
            console.log(response)
            if (response.status === 200) {
                if (params.id) {
                    setPageErrors(response.data.data.info.language_id !== state.form_active_lang.activeLangId && true)
                    setValue('title', response.data.data.info.title);
                    setValue('description', response.data.data.info.description);
                    setValue('address', response.data.data.info.address);
                    setValue('phone', response.data.data.phone);
                    setValue('email', response.data.data.email);
                    setValue('facebook', response.data.data.meta['facebook'] ?? '');
                    setValue('youtube', response.data.data.meta['youtube'] ?? '');
                    setValue('keywords', response.data.data.meta['keywords'] ?? '');
                    setValue('google_key', response.data.data.keys['google_key'] ?? '');

                    if (response.data.data.status === 1) {
                        setPageStatus(true)
                    } else {
                        setPageStatus(false)
                    }

                    const coversData = response.data.data.info.covers
                    setUpdatedCovers(coversData)
                }
            }
        }).catch(err => {
            console.log(err.response)
        }).finally(() => {
            setLoading(false)
        });
    }

    // create form
    const create = (data) => {
        if (params.id) {
            // update Page
            http.post('settings/update/' + params.id,
                {
                    ...data,
                    language_id: state.form_active_lang.activeLangId ?? 1,
                    status: pageStatus === true ? 1 : 2,
                    cover_id: Array.isArray(state.selected_covers) ? state.selected_covers.map(item => item.id) : null,
                    cover_type: Array.isArray(state.selected_covers) ? state.selected_covers.map(item => item.coverType) : null,
                }
            ).then((response) => {
                if (response.status === 200) {
                    setAddSuccess(true)
                    toast.success('Settings Updated!')
                }
            }).catch(err => {
                console.log(err.response)
                errorAlerts(err.response.status, err.response.statusText, err.response.data.errors)
            });
        } else {
            // create
            http.post('settings',
                {
                    ...data,
                    language_id: state.form_active_lang.activeLangId ?? 1,
                    status: pageStatus === true ? 1 : 2,
                    cover_id: Array.isArray(state.selected_covers) ? state.selected_covers.map(item => item.id) : null,
                    cover_type: Array.isArray(state.selected_covers) ? state.selected_covers.map(item => item.coverType) : null,
                }
            ).then((response) => {
                if (response.status === 200) {
                    setAddSuccess(true)
                    toast.success('Settings Created!')
                    navigate(`/settings/edit/` + response.data.id)
                }
            }).catch(err => {
                console.log(err.response)
                errorAlerts(err.response.status, err.response.statusText, err.response.data.errors)
            });
        }
    };

    // Page Load use Effect
    useEffect(() => {
        getPageConfig()
        if (params.id) {
            getEditData()
        }
    }, [addSuccess, state.form_active_lang.activeLangId, params.id])

    return (
        <>
            <div className="col-md-12 col-xl-12 bg-w">
                <div className="">
                    <form className="row " onSubmit={handleSubmit(create)}>
                        <div className="col-md-9 col-xl-9">
                            <div className="card">
                                <div className="card-header lite-background">
                                    <div className="row justify-content-between">
                                        <div className="col-md-4 ">
                                            <h5 className="card-title mb-0">
                                                <Box component="span" sx={{ '& > img': { mr: 2, flexShrink: 0 } }}>
                                                    <img
                                                        loading="lazy"
                                                        width="20"
                                                        src={`https://flagcdn.com/w20/${state.form_active_lang.code && state.form_active_lang.code === 'KA' ? 'ge' : state.form_active_lang.code && state.form_active_lang.code.toLowerCase()}.png`}
                                                        srcSet={`https://flagcdn.com/w40/${state.form_active_lang.code && state.form_active_lang.code === 'KA' ? 'ge' : state.form_active_lang.code && state.form_active_lang.code.toLowerCase()}.png 2x`}
                                                        alt=""
                                                    />
                                                </Box>
                                                {params.id ? translate('editPage', state.lang.code) : translate('addCategory', state.lang.code)}
                                            </h5>
                                        </div>
                                        <div className="col-md-8 text-right">
                                            <div className="card-actions float-end">
                                                <ul className='nav lang'>
                                                    <UseFormLang leave={params.id || localStorage.getItem('sureAlert') === '1' ? null : true} />
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {checkTranslate(pageErrors, params.id, state.form_active_lang.label)}
                                <div className={"tab-pane "} style={{ display: tabs.tab_1 === true ? 'block' : 'none' }}>
                                    {loading && params.id ? <div className='text-center p-5'><CircularProgress /><p>Loading Data...</p></div> : <div className="card-body">
                                        {/*Start 2 Section*/}
                                        <div className='row'>
                                            {/*1 Section*/}
                                            <div className="col-8">
                                                <div className="mb-3 col-md-12">
                                                    <label htmlFor="inputFirstName"
                                                           className='pb-2 font_form_title font-weight-bold'>{translate('siteName', state.lang.code)}</label>
                                                    <input type="text" className="form-control p-2 font_form_text"
                                                           id="inputFirstName"
                                                           placeholder={translate('siteName', state.lang.code)}
                                                           {...register('title', {
                                                               required: "სახელი შეყვანა აუცილებელია",
                                                               minLength: {
                                                                   value: 1,
                                                                   message: "გთხოვთ სრულად შეიყვანეთ სახელი"
                                                               }
                                                           })}
                                                    />
                                                    {errors.title && <div className='form-error-messages-text font_form_text'>{errors.site_name?.message}</div>}
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="inputEmail02"
                                                           className='pb-2 font_form_title font-weight-bold'>ვებ გვერდის აღწერა</label>
                                                    <textarea type="text" className="form-control p-2 font_form_text"
                                                              id="inputEmail02"
                                                              placeholder='ვებ გვერდის მოკლე აღწერა'
                                                              {...register('description', {})}
                                                    ></textarea>
                                                    {errors.description && <div
                                                        className='form-error-messages-text font_form_text'>{errors.description.message}</div>}
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="inputEmail02"
                                                           className='pb-2 font_form_title font-weight-bold'>საკვანძო სიტყვები</label>
                                                    <input type="text" className="form-control p-2 font_form_text"
                                                           id="inputEmail02"
                                                           placeholder='rissi,მომსახურება,დეტალები'
                                                           {...register('keywords', {})}
                                                    />
                                                    {errors.keywords && <div
                                                        className='form-error-messages-text font_form_text'>{errors.keywords.message}</div>}
                                                </div>

                                                <h1 className="half-title border-warning font_form_title">საიტის საკონტაქტო ინფორმაცია</h1>

                                                <div className="mb-3">
                                                    <label htmlFor="inputEmail01"
                                                           className='pb-2 font_form_title font-weight-bold'>{translate('address', state.lang.code)}</label>
                                                    <input type="text" className="form-control p-2 font_form_text"
                                                           id="inputEmail01"
                                                           placeholder={translate('address', state.lang.code)}
                                                           {...register('address', {})}
                                                    />
                                                    {errors.address && <div className='form-error-messages-text font_form_text'>{errors.address.message}</div>}
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="inputEmail02"
                                                           className='pb-2 font_form_title font-weight-bold'>{translate('email', state.lang.code)}</label>
                                                    <input type="text" className="form-control p-2 font_form_text"
                                                           id="inputEmail02"
                                                           placeholder={translate('email', state.lang.code)}
                                                           {...register('email', {
                                                               pattern: /^\S+@\S+$/i,
                                                           })}
                                                    />
                                                    {errors.email && <div className='form-error-messages-text font_form_text'>{errors.email.message}</div>}
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="inputEmail02"
                                                           className='pb-2 font_form_title font-weight-bold'>{translate('phone', state.lang.code)}</label>
                                                    <input type="text" className="form-control p-2 font_form_text"
                                                           id="inputEmail02"
                                                           placeholder={translate('phone', state.lang.code)}
                                                           {...register('phone', {})}
                                                    />
                                                    {errors.email && <div className='form-error-messages-text font_form_text'>{errors.email.message}</div>}
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="inputEmail08"
                                                           className='pb-2 font_form_title font-weight-bold'>Google Key</label>
                                                    <input type="text" className="form-control p-2 font_form_text"
                                                           id="inputEmail08"
                                                           placeholder='Google Key'
                                                           {...register('google_key', {})}
                                                    />
                                                    {errors.google_key && <div className='form-error-messages-text font_form_text'>{errors.google_key.message}</div>}
                                                </div>
                                            </div>
                                            {/*End first Section*/}
                                            {/* start Section tow*/}
                                            <div className="col-4">
                                                <div className="mb-3">
                                                    <label htmlFor="inputEmail02"
                                                           className='pb-2 font_form_title font-weight-bold'>Instagram</label>
                                                    <input type="text" className="form-control p-2 font_form_text"
                                                           id="inputEmail02"
                                                           placeholder='Instagram'
                                                           {...register('instagram', {})}
                                                    />
                                                    {errors.instagram && <div
                                                        className='form-error-messages-text font_form_text'>{errors.instagram.message}</div>}
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="inputEmail02"
                                                           className='pb-2 font_form_title font-weight-bold'>FaceBook</label>
                                                    <input type="text" className="form-control p-2 font_form_text"
                                                           id="inputEmail02"
                                                           placeholder='FaceBook'
                                                           {...register('facebook', {})}
                                                    />
                                                    {errors.facebook && <div
                                                        className='form-error-messages-text font_form_text'>{errors.facebook.message}</div>}
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="inputEmail02"
                                                           className='pb-2 font_form_title font-weight-bold'>Youtube</label>
                                                    <input type="text" className="form-control p-2 font_form_text"
                                                           id="inputEmail02"
                                                           placeholder='Youtube'
                                                           {...register('youtube', {})}
                                                    />
                                                    {errors.Youtube && <div
                                                        className='form-error-messages-text font_form_text'>{errors.Youtube.message}</div>}
                                                </div>
                                            </div>
                                            {/* END start Section tow*/}
                                        </div>
                                    </div>}
                                </div>
                                {/*Meta Tags */}

                                {/*End meta Tags */}
                            </div>
                        </div>
                        <div className="col-md-3 col-xl-3 bg-w my-left-side-toolbar">
                            <div className="card  lite-background">
                                <div className="card-header" style={{ borderBottom: "1px dashed #a2a2a2" }}>
                                    <UseButtonBar />
                                </div>
                                <div className="card-header" style={{ borderBottom: "1px dashed #a2a2a2", background: '#fff' }}>
                                    <div className="row ">
                                        <div className='col-12 text-center align-middle page-statuses'>
                                            <div className='input-style-border-switch'>
                                                <Switch id="toAction" checked={pageStatus} onChange={(e) => setPageStatus(e.target.checked)} />
                                                <label htmlFor="toAction" className='pb-2 font_form_title'>Web page Status</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*    Show added info */}
                            <div className="mb-3">
                                <UseFileManager coverTypes={coverTypes} updateData={updatedCovers} />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
export default Settings;